import { createSelector } from 'reselect';

const getAuth = (state) => state.auth;
export const getAuthData = createSelector(getAuth, ({ data }) => data);
export const getAuthDataUserId = createSelector(getAuthData, ({ userId }) => userId);
export const getAuthDataOrganisation = createSelector(
  getAuthData,
  ({ organisation }) => organisation,
);
export const getAuthDataOrganisationId = createSelector(
  getAuthData,
  ({ organisationId }) => organisationId,
);
export const getAuthDataToken = createSelector(getAuthData, ({ token }) => token);
export const getAuthDataUser = createSelector(getAuthData, ({ user }) => user);
